import styled from "styled-components"; 


export const ContainerFooterTable = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    color: var(--color-latex30);
  }
  .pointer {
    cursor: pointer;
  }
`;
